// src/constants.js
// App-wide shared constants
import i18n from "./i18n";

export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "https://ourcuration.com";

export const ACCOUNT_COLORS = ["#E8593C","#3B8BD4","#1D9E75","#BA7517","#7F77DD","#D4537E","#0F6E56","#993C1D"];
export function getAccountColor(accountId, accounts) {
  const index = accounts.findIndex((a) => a.id === accountId);
  return ACCOUNT_COLORS[index % ACCOUNT_COLORS.length] || "#888";
}

export const FOLLOWING_COLORS = ["#E8593C","#3B8BD4","#1D9E75","#BA7517","#7F77DD","#D4537E"];
export const getFollowingColor = (idx) => FOLLOWING_COLORS[idx % FOLLOWING_COLORS.length];

export const STATUS_COLOR = {
  want_to_go:   { bg: "#FEF3CD", color: "#BA7517" },
  visited:      { bg: "#E0F4EC", color: "#1D9E75" },
  want_revisit: { bg: "#FCE4EE", color: "#D4537E" },
};

export const STATUS_EMOJI = {
  want_to_go: "🔖",
  visited: "✅",
  want_revisit: "❤️",
};

export const STATUS_LABEL = {
  get want_to_go() { return i18n.t("status.want_to_go"); },
  get visited() { return i18n.t("status.visited"); },
  get want_revisit() { return i18n.t("status.want_revisit"); },
};

export const SHARED_CAT_COLOR = {
  restaurant:    "#E8593C",
  cafe:          "#3B8BD4",
  bar:           "#7F77DD",
  general_store: "#BA7517",
};

export const BEST_CATEGORIES = [
  { key: "restaurant", emoji: "🍽", get label() { return i18n.t("category.restaurant"); } },
  { key: "cafe",       emoji: "☕", get label() { return i18n.t("category.cafe"); } },
  { key: "bar",        emoji: "🍸", get label() { return i18n.t("category.bar"); } },
  { key: "general_store", emoji: "🛍", get label() { return i18n.t("category.shop"); } },
];

/* ── Google Place type → app category ── */
const GOOGLE_TYPE_MAP = {
  restaurant: "restaurant", meal_delivery: "restaurant", meal_takeaway: "restaurant",
  bakery: "restaurant", food: "restaurant",
  cafe: "cafe", coffee_shop: "cafe",
  bar: "bar", night_club: "bar",
  store: "general_store", shopping_mall: "general_store", clothing_store: "general_store",
  convenience_store: "general_store", supermarket: "general_store", grocery_or_supermarket: "general_store",
  department_store: "general_store", shoe_store: "general_store", electronics_store: "general_store",
  book_store: "general_store", home_goods_store: "general_store", jewelry_store: "general_store",
  pet_store: "general_store", hardware_store: "general_store", furniture_store: "general_store",
};
export function mapGoogleCategory(types) {
  if (!types?.length) return null;
  for (const t of types) {
    if (GOOGLE_TYPE_MAP[t]) return GOOGLE_TYPE_MAP[t];
  }
  return null;
}

export function formatTime(dateStr) {
  if (!dateStr) return "";
  const t = i18n.t.bind(i18n);
  const diff = Math.floor((new Date() - new Date(dateStr)) / 1000);
  if (diff < 60) return t("time.just_now");
  if (diff < 3600) return `${Math.floor(diff / 60)}${t("time.minutes_ago")}`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}${t("time.hours_ago")}`;
  return `${Math.floor(diff / 86400)}${t("time.days_ago")}`;
}
